import { FeatureFlag } from '@/types/featureFlag';

// Fetched once at boot by routes, so reads of these below resolve from the cache. A key set goes
// to the network if any one member is missing, so a flag asked for alongside these belongs here.
export const ALL_VISITS_TABLE_FLAGS = {
    bulkCancel: FeatureFlag.DASHBOARD_BULK_CANCELLATION_ALL_VISITS,
    bulkReassign: FeatureFlag.DASHBOARD_BULK_VISIT_REASSIGNMENT,
    showPatientTags: FeatureFlag.DASHBOARD_PATIENT_TAGS_IN_TABLES,
    horizontalScrollButtons: FeatureFlag.DASHBOARD_TABLE_HORIZONTAL_BUTTONS,
    pinActions: FeatureFlag.DASHBOARD_TABLE_PINNED_ACTIONS,
    condensedPadding: FeatureFlag.DASHBOARD_TABLE_CONDENSED_PADDING,
    hasOrders: FeatureFlag.ORDERS,
};

export const ALL_VISITS_FLAGS = {
    ...ALL_VISITS_TABLE_FLAGS,
    hasVisitsMap: FeatureFlag.ALL_VISITS_MAP,
    hasClinicianHomePins: FeatureFlag.DASHBOARD_CLINICIAN_HOME_PINS_ON_MAPS,
    hasReassignV3: FeatureFlag.DASHBOARD_VISIT_REASSIGNMENT_FLOW,
};
